import styled from 'styled-components';

export const Container = styled.div`
  .btn {
    border: none;
    outline: none;
    box-shadow: none;
  }

  .nav-arrow {
    filter: invert(17%) sepia(92%) saturate(2476%) hue-rotate(206deg) brightness(92%) contrast(101%);
  }

  .btn-link {
    text-decoration: none;
  }

  .btn:focus {
    outline: none;
    box-shadow: none;
    text-decoration: none !important;
  }

  .shadow-categories {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  }

  .bg-ia {
    background-color: ${(props) => props.theme.$secondary_green_light};
  }

  .rounded-3 {
    border-radius: 0.75rem;
  }

  @media only screen and (min-width: 769px) {
    .representant-tools .card-container {
      flex: 1 1 9rem;
    }
  }
`;
